export const SelectBox = {
	selectors: {
		selectSelector: Array.prototype.slice.call(document.querySelectorAll('.js-selectbox')),
		actionsButtonsSelectors: Array.prototype.slice.call(document.querySelectorAll('.js-selectbox--action-button'))
	},

	init: function() {
		this.renderCustomSelect();
		this.registerEvents();
	},

	registerEvents: function() {
		let self = this;

		document.addEventListener('click', function(e) {

			if (typeof e.target.closest !== 'function' && document.querySelector('.js-selectbox.is-open')) {
				self.openSelectBox(document.querySelector('.js-selectbox.is-open'), 'close');
				return;
			}

			let x = e.target.closest('.js-selectbox');

			if (!x && document.querySelector('.js-selectbox.is-open')) {
				self.openSelectBox(document.querySelector('.js-selectbox.is-open'), 'close');
			}

			if (x) {
				let xID = self.selectors.selectSelector.indexOf(x);

				self.selectors.selectSelector.forEach(function(el, i) {
					if (i !== xID && el.classList.contains('is-open')) {
						el.classList.remove('is-open');
					}
				})

				if (e.target.classList.contains('c-selectbox__custom-item') || e.target.closest('.c-selectbox__custom-item')) {
					self.updateOptionsArray(x, e.target.closest('.c-selectbox__custom-item').dataset.value);

					self.updateLabelText(JSON.parse(x.dataset.option), x);

					self.selectCustomItem(JSON.parse(x.dataset.option), x);

					self.updateHiddenSelect(JSON.parse(x.dataset.option), x.dataset.selectid);
				}

				if (e.target.classList.contains('c-selectbox__custom-label') || e.target.closest('.icon-svg') ||
					e.target.closest('.c-selectbox__custom-label .c-selectbox__label-right') ||
					e.target.closest('.c-selectbox__custom-label .c-selectbox__label-text')) {
					self.openSelectBox(x, 'toggle');
				} else {
					self.openSelectBox(document.querySelector('.js-selectbox.is-open'), 'close');
				}
			}
		});

		self.selectors.actionsButtonsSelectors.forEach(function(button) {
			button.addEventListener('click', function(event) {
				self.checkValidityOnActionButtonClickEvent(button, event);
			});
		});

		// on select change event update fake select label
		self.selectors.selectSelector.forEach(function(select) {
			if (select.dataset.selectid) {
				let input = document.getElementById(select.dataset.selectid);
				if (input) {
					input.addEventListener('change', function() {
						self.updateOptionsArray(select, input.value);
						self.updateLabelText(JSON.parse(select.dataset.option), select);
					});
				}
			}
		});
	},

	renderCustomSelect: function() {
		let self = this;

		self.selectors.selectSelector.forEach(function(x) {

			let options = self.optionsToArray(x);
			let element = self.createCustomSelect(options);
			let label = self.createCustomLabel(options);

			let labelText = self.customLabelText(options, false);

			x.querySelector('select').classList.add('is-hidden');

			label.innerHTML += labelText;

			if (x.getAttribute('data-add') && label) {
				label.classList.add(x.getAttribute('data-add'));
			}

			let firstItem = options[0];


			if (firstItem.newPrice) {
				let prices = document.createElement('span');
				prices.classList.add('c-selectbox__label-right');
				prices.classList.add('c-price');
				prices.classList.add('c-price--inline');
				prices.classList.add('c-price--in-selectbox');
				prices.classList.add('u-mobile-hidden');
				prices.innerHTML = `<span class="c-price__old">${firstItem.oldPrice}</span><span class="c-price__new">${firstItem.newPrice}</span>`;
				label.appendChild(prices);
			}

			x.appendChild(label);

			x.appendChild(element);

			self.selectCustomItem(options, x);

			if (x.dataset.selectid) {
				self.updateHiddenSelect(options, x.dataset.selectid);
			}
		});
	},

	createCustomSelect: function(_options) {
		let self = this;
		let selectWrapper = document.createElement('div');

		let arrayOptions = _options;

		selectWrapper.classList.add('c-selectbox__custom-select');
		selectWrapper.classList.add('c-shadow-block');

		arrayOptions.forEach(function(x) {

			if (x.optionDisabled) {
				// selectWrapper.innerHTML += `<span class="c-selectbox__custom-item is-disabled" data-value="${x.optionValue}">${x.optionText}</span>`;
				selectWrapper.innerHTML += `<span class="c-selectbox__custom-item is-disabled" data-value="${x.optionValue}"><span class="">${x.optionText}<span></span>`;
			} else {
				if (x.optionHref === false) {

					if (x.newPrice) {
						selectWrapper.innerHTML += `
							<span class="c-selectbox__custom-item" data-value="${x.optionValue}"><span class="c-selectbox__label-text">${x.optionText}</span>
								<span class="c-selectbox__label-right c-price c-price--inline c-price--in-selectbox u-pull-right prices-wrapper">
									<span class="c-price__old u-mobile-hidden">
										${x.oldPrice}
									</span>
									<span class="c-price__new">
										${x.newPrice}
									</span>
								</span>
							</span>`;
					} else {
						selectWrapper.innerHTML += `<span class="c-selectbox__custom-item" data-value="${x.optionValue}"><span class="c-selectbox__label-text">${x.optionText}<span></span>`;
					}
				} else {
					selectWrapper.innerHTML += `<a class="c-selectbox__custom-item" data-value="${x.optionValue}" href="${x.optionHref}">${x.optionText}</a>`;
				}
			}
		});

		return selectWrapper;
	},

	selectCustomItem: function(_options, _selector) {
		let selected;

		_options.forEach(function(x) {
			if (x.optionSelected) {
				selected = x.optionValue;
			}
		});

		Array.prototype.slice.call(_selector.querySelectorAll('.c-selectbox__custom-item')).forEach(function(x) {
			x.classList.remove('is-active');

			if (x.dataset.value === selected) {
				x.classList.add('is-active');
			}
		})
	},

	createCustomLabel: function(_options) {
		let self = this;
		let labelWrapper = document.createElement('div');

		labelWrapper.classList.add('c-selectbox__custom-label');

		return labelWrapper;
	},

	customLabelText: function(_options, withPrice = true) {
		let text;

		_options.forEach(function(x) {
			if (x.optionSelected === true) {
				text = `<span class="c-selectbox__label-text">${x.optionText}</span>`

				if (x.newPrice && withPrice) {
					text += `
						<span class="c-selectbox__label-right c-price c-price--inline c-price--in-selectbox u-pull-right prices-wrapper u-mobile-hidden">
							<span class="c-price__old">
								${x.oldPrice}
							</span>
							<span class="c-price__new">
								${x.newPrice}
							</span>
						</span>
						`
				}
			}
		});

		return text;
	},

	updateLabelText: function(_options, _selector) {
		let self = this;

		let labelText = self.customLabelText(_options);

		_selector.querySelector('.c-selectbox__custom-label').innerHTML = labelText;
	},

	optionsToArray: function(_selector) {
		let self = this;
		let array = Array.prototype.slice.call(_selector.querySelectorAll('option'));
		let countSelectedOption = 0;
		let setDataOption = [];

		array.forEach(function(x) {
			let text = x.innerText;
			let val = x.getAttribute('value');
			let selected = x.hasAttribute('selected'); // ? true : false;
			let disabled = x.hasAttribute('disabled'); // ? true : false;
			let href = x.dataset.href ? x.dataset.href : false;
			let oldPrice = x.dataset.oldPrice ? x.dataset.oldPrice : '';
			let newPrice = x.dataset.newPrice ? x.dataset.newPrice : '';

			if (x.hasAttribute('selected')) {
				countSelectedOption++;
			}

			setDataOption.push({optionText: text, optionValue: val, optionSelected: selected, optionDisabled: disabled, optionHref: href, oldPrice: oldPrice, newPrice: newPrice});
		});

		if (countSelectedOption === 0) {
			setDataOption[0].optionSelected = true;
		}

		_selector.dataset.option = JSON.stringify(setDataOption);

		return setDataOption;
	},

	updateOptionsArray: function(_selector, _value) {
		let self = this;
		let options = JSON.parse(_selector.dataset.option);

		options.forEach(function(x) {
			x.optionSelected = x.optionValue === _value;
		});

		_selector.dataset.option = JSON.stringify(options);
	},

	openSelectBox: function(_selector, _state) {
		if (_state === 'toggle') {
			_selector.classList.toggle('is-open');
		} else {
			if (_selector !== null) {
				_selector.classList.remove('is-open');
			}
		}
	},
	updateHiddenSelect: function (_options, _selectid) {

		if (! _selectid) {
			return;
		}

		let select = document.getElementById(_selectid);
		let opts = select.options;
		let option = '';

		_options.forEach(function(x) {
			if (x.optionSelected === true) {
				option = x.optionValue;
			}
		});

		for (var opt, j = 0; opt = opts[j]; j++) {
			if (opt.value === option) {
				select.selectedIndex = j;
				break;
			}
		}

		// remove invalid class on active option change
		select.closest('.js-selectbox').classList.remove('c-selectbox--invalid');

		// standard `change` event dispatching
		select.dispatchEvent(new CustomEvent('change'));

		/**
		 * reservation calendar is listening to it
		 */
		select.dispatchEvent(new CustomEvent('selectbox-changed'));
	},

	checkValidityOnActionButtonClickEvent: function(button, event) {
		if (! button.dataset.selectid) {
			return;
		}

		let select = document.querySelector('#' + button.dataset.selectid);
		if (! select) {
			return;
		}

		let active = select.options[select.selectedIndex];
		let container = select.closest('.js-selectbox');

		if (! active.disabled) {
			container.classList.remove('c-selectbox--invalid');
			container.classList.add('c-selectbox--valid');
			return;
		}

		event.preventDefault();
		event.stopImmediatePropagation();

		container.classList.remove('c-selectbox--valid');
		container.classList.add('c-selectbox--invalid');
	}
};

SelectBox.init();
